// extracted by mini-css-extract-plugin
module.exports = {"icon":"format_icon__C5mfs","label":"format_label__3-CDl","text":"format_text__LmTYn"};